// The API no longer sends a per-user `avatarColor` - derive a stable gradient client-side
// so the same user always gets the same color across renders/sessions.
const GRADIENTS = [
  'from-indigo-500 to-purple-600',
  'from-amber-400 to-orange-500',
  'from-cyan-400 to-blue-500',
  'from-emerald-400 to-teal-600',
  'from-rose-500 to-red-600',
  'from-fuchsia-500 to-pink-600',
  'from-yellow-400 to-amber-500',
];

export function getAvatarGradient(seed) {
  const str = String(seed || '');
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return GRADIENTS[hash % GRADIENTS.length];
}
